/**
 * Implements fetching of aspect ratios via the "Vimeo Player SDK" in the front end.
 *
 * The actual aspect ratios of Vimeo videos are needed for `<iframe>` size calculations
 *
 * @see https://developer.vimeo.com/player/sdk
 */
(() => {
    if (typeof Vimeo === 'undefined') {
        return;
    }

    function setAspectRatios() {
        document.querySelectorAll('.js-vimeo-iframe').forEach((iframe) => {
            let player = new Vimeo.Player(iframe);

            player.getVideoWidth().then((width) => {
                player.getVideoHeight().then((height) => {
                    Promise.all([
                        player.getVideoWidth(),
                        player.getVideoHeight(),
                    ]).then((dimensions) => {
                        const [width, height] = dimensions;
                        iframe.style.setProperty(
                            '--aspect-ratio',
                            `${width / height}`
                        );
                        iframe.style.setProperty(
                            '--inverse-aspect-ratio',
                            `${height / width}`
                        );
                    });
                });
            });
        });
    }

    setAspectRatios();
})();
